import Model from './Model';
import Vue from 'vue';

export default class SurveyTemplate extends Model {
    title;
    type;
    questions;

    toJson() {
        return {
            ...this,
            type: this.type.value ? this.type.value : this.type,
            questions: this.questions ? this.transforQuestion(this.questions) : []
        };
    }

    // Transform question type from { type, value } object to string
    // Set the order property according to the array index
    // Set required always to be a boolean: no null/undefined
    transforQuestion(questions) {
        return questions.map((question, index) => {
            question.type = question.type.value ? question.type.value : question.type;
            question.order = index;
            question.required = !!question.required;
            question.allow_other = !!question.allow_other;
            return question;
        });
    }

    // Override the update function to also add ids to the questions of the template.
    update(fields = null) {
        this.updated = new Date().getTime();
        let path = this.constructor.apiPath() + '/' + this.id;
        let data = fields ? fields : this.toJson();
        return Vue.axios.patch(path, data).then(resp => {
            return this.fill({...this, questions: resp.data.questions });
        }).catch(({ status, errors }) => {
            throw { status, errors };
        });
    }

    static apiPath() {
        return 'survey-templates';
    }
}



// WEBPACK FOOTER //
// ./src/models/SurveyTemplate.js